import PostService from './PostService'
import LocalStorageService from './LocalStorageService'

export default class HotelService {
  constructor(source) {
    this.postService = new PostService(this, true, '')
    this.localStorageService = new LocalStorageService(this)
  }

  // ListarHoteisVinculados(data, callback, callbackErro) {
  //   let url = process.env.VUE_APP_URL_BBRAS + 'webapi/Legado/api/hotel/ListarHoteis'
  //   //this.postService.Post(url, data, callback, callbackErro)
  //   this.postService.Get(url, callback, callbackErro)
  // }

  PesquisarHotel(filtro, callback, callbackErro) {
    let url = process.env.VUE_APP_URL_BBRAS + 'webapi/Legado/api/hotel/ListarHotelGeral?filtro=' + filtro
    this.postService.Post(url, null, callback, callbackErro)
  }

  ListarHoteisVinculados(data, callback, callbackErro) {
    let url = process.env.VUE_APP_URL_BBRAS + 'webapi/Legado/api/hotel/ListarHoteis'
    this.postService.Get(url, (res) => {
      callback(res)
    })
  }
}
